<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11oFqLA/tc-custom/9780463434390.jpg?1693938828212" alt="This image is the cover for the book Mark's Midlife, Seduced by Shark Shifters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mark's Midlife, Seduced by Shark Shifters
      </h1>
      <p class="bookDescription body article font2">
        <p>Mark Dauphin loves his nephews, Sam and Logan, and he'll do anything his brother-in-law Cole asks, but when Cole wants Mark to play nice with Stefano Magnussi, Mark isn't sure he can comply. Stefano is hotter than fire, but Mark can't see past the fact that Stefano is one of those guys, the type of men who date guys half their age, the type of guys who made Mark give up on dating.<br/><br/>Of course, a little wine and several cocktails later, Mark finds himself dropping more than his defenses with Stefano. But when Logan and the rest of Mark's family surprise them in the morning, Mark and Stefano are suddenly at odds.<br/><br/>When Logan's ego is wounded, not only does Mark find himself desperate to fix his relationship with his nephew, but he also questions whether his night with this beautiful man meant anything to either of them. Mark isn't given much time to reflect though, as the war that's been brewing between the shivers comes to a violent head, and he soon learns that sometimes you just have to trust in those around you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rafe Jadison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07a9bfd4